import { render, staticRenderFns } from "./AugmentationsCard.vue?vue&type=template&id=8aa3dfa4&scoped=true&"
import script from "./AugmentationsCard.vue?vue&type=script&lang=js&"
export * from "./AugmentationsCard.vue?vue&type=script&lang=js&"
import style0 from "./AugmentationsCard.vue?vue&type=style&index=0&id=8aa3dfa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa3dfa4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VFlex,VImg,VTooltip})
